import {types} from './types';

const initialState = {
    history: {
        list: [],
        page: 0
    }
}

export function creditHistoryReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST_CREDIT_HISTORY:
            return { ...state, history: action.payload};

        default:
            return state
    }
}